import { gql } from "@apollo/client";

const GET_CONNECTION = gql`
  query connection($id: ID) {
    connection(id: $id) {
      id
      type
      status
      enabled
      recordId
      recordType
      installationId
      organizationSlug
      repositories {
        id
        fullName
        name
      }
      sender {
        id
        login
      }
    }
  }
`;

const GET_LATEST_ORG_REPO_ACTIVITY = gql`
  query latestOrgRepoActivity($organizationId: ID!, $repositories: [String!]) {
    latestOrgRepoActivity(organizationId: $organizationId, repositories: $repositories) {
      id
      fullName
      latestImportAt
    }
  }
`;

const GET_CONNECTIONS = gql`
  query connections($filters: ConnectionFilter) {
    connections(filters: $filters) {
      nodes {
        id
        type
        enabled
      }
    }
  }
`;

export { GET_CONNECTION, GET_LATEST_ORG_REPO_ACTIVITY, GET_CONNECTIONS };
